import React, {useEffect} from 'react';
import AutoConversionToggle from "../AutoConversionToggle";
import {formatAccount} from "../../features/ValueFormater";
import MerchantEnrollmentAPI from "../../api/MerchantEnrollmentAPI";
import {Spinner} from "react-bootstrap";
import ProgressLoading from "../ProgressLoading";

function MerchantConfirmation({payload, handleNext}) {
    const [selectedLogoImage, setSelectedLogoImage] = React.useState(null);
    const [selectedCoverImage, setSelectedCoverImage] = React.useState(null);

    const {
        MerchantEnrollmentInformation,
        MerchantEnrollmentProfile,
        MerchantEnrollmenPaymentInfo,
        Additionals
    } = payload;

    const {SaveMerchantEnrollmentData, setUploadLoading , response, uploadLoading, progress} = MerchantEnrollmentAPI();

    useEffect(() => {
        const reader = new FileReader();
        reader.onloadend = () => {
            setSelectedLogoImage(reader.result);
        };

        if (MerchantEnrollmentProfile.MerchantLogo) {
            reader.readAsDataURL(MerchantEnrollmentProfile.MerchantLogo);
        }
    }, [MerchantEnrollmentProfile.MerchantLogo]);

    useEffect(() => {
        const reader = new FileReader();
        reader.onloadend = () => {
            setSelectedCoverImage(reader.result);
        };

        if (MerchantEnrollmentProfile.MerchantCover) {
            reader.readAsDataURL(MerchantEnrollmentProfile.MerchantCover);
        }
    }, [MerchantEnrollmentProfile.MerchantCover]);

    const handleSubmit = async() => {
        const {Additionals, ...data} = payload;

        SaveMerchantEnrollmentData(data).then((res) => {
            setUploadLoading(false);

            if(res?.GlobalCode === 200){
                handleNext();
            }
        });
    };

    useEffect(() => {
        if (response && response.GlobalCode === 0) {
            handleNext();
        }
    }, [response]);

    return (
        <>
            <div className="account-info">
                <div className="form-container">
                    <div className="form-title">
                        MERCHANT INFORMATION
                    </div>
                    <div className="info-container">
                        <div className="info-data">
                            <div className="info-title">MerchantName</div>
                            <div className="info">{MerchantEnrollmentInformation?.MerchantName}</div>
                        </div>

                        <div className="info-data">
                            <div className="info-title">Merchant Category</div>
                            <div className="info">{Additionals?.Category}</div>
                        </div>

                        <div className="info-data">
                            <div className="info-title">Merchant Sub-Category</div>
                            <div className="info">{Additionals?.SubCategory}</div>
                        </div>

                        <div className="info-data">
                            <div className="info-title">District</div>
                            <div className="info">{Additionals?.District}</div>
                        </div>

                        <div className="info-data">
                            <div className="info-title">City</div>
                            <div className="info">{Additionals?.City}</div>
                        </div>

                        <div className="info-data">
                            <div className="info-title">Address</div>
                            <div className="info">{MerchantEnrollmentInformation?.Address}</div>
                        </div>

                        <div className="info-data">
                            <div className="info-title">Phone Number</div>
                            <div className="info">{MerchantEnrollmentInformation?.PhoneNumber}</div>
                        </div>

                        <div className="info-data">
                            <div className="info-title">Mobile Number</div>
                            <div className="info">{MerchantEnrollmentInformation?.MobileNumber}</div>
                        </div>

                        <div className="info-data">
                            <div className="info-title">Has delivery</div>
                            <div className="info">{MerchantEnrollmentInformation.DeliveryNumber? "Yes": "No"}</div>
                        </div>

                    </div>

                    <div className="form-title">
                        PAYMENT INFORMATION
                    </div>
                    <div className="info-container">
                        <AutoConversionToggle
                            isChecked={MerchantEnrollmenPaymentInfo.AutoConversionToUSD}
                            handle_toggleChange={()=>{}}
                            convertText="Convert LBP to USD as payments settle"
                            disabled={MerchantEnrollmenPaymentInfo.AutoConversionToLBP}
                        />

                        <AutoConversionToggle
                            isChecked={MerchantEnrollmenPaymentInfo.AutoConversionToLBP}
                            handle_toggleChange={()=>{}}
                            convertText="Convert USD to LBP as payments settle"
                            disabled={MerchantEnrollmenPaymentInfo.AutoConversionToUSD}
                        />

                        <div className="info-data">
                            <div className="info-title">Limit Per Transaction (USD)</div>
                            <div className="info">{formatAccount(MerchantEnrollmenPaymentInfo.LimitPerTransactionUSD, 1)}</div>
                        </div>

                        <div className="info-data">
                            <div className="info-title">Limit Per Transaction (LBP)</div>
                            <div className="info">{formatAccount(MerchantEnrollmenPaymentInfo.LimitPerTransactionLBP, 2)}</div>
                        </div>
                    </div>

                    <div className="form-title">
                        MERCHANT PROFILE
                    </div>
                    <div className="photos">
                        <div className="row">
                            <div className="col-2 p-3">
                                <div className=" photo logo">
                                    <img src={selectedLogoImage} alt=""/>
                                </div>
                            </div>
                            <div className="col-4 p-3">
                                <div className="cover photo">
                                    <img src={selectedCoverImage} alt=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="info-container">
                        {MerchantEnrollmentProfile.Website &&
                            <div className="info-data">
                                <div className="info-title">Website</div>
                                <div className="info">{MerchantEnrollmentProfile.Website}</div>
                            </div>
                        }
                        {
                            MerchantEnrollmentProfile.Facebook &&
                            <div className="info-data">
                                <div className="info-title">Facebook</div>
                                <div className="info">{MerchantEnrollmentProfile.Facebook}</div>
                            </div>
                        }
                        {
                            MerchantEnrollmentProfile.Instagram &&
                            <div className="info-data">
                                <div className="info-title">Instagram</div>
                                <div className="info">{MerchantEnrollmentProfile.Instagram}</div>
                            </div>
                        }

                    </div>

                </div>
            </div>
            <button onClick={handleSubmit} className="continue-btn">{uploadLoading? <Spinner animation="border" role="status" /> : "Confirm & Submit"}</button>
            <ProgressLoading progress={progress}/>
        </>
    );
}

export default MerchantConfirmation;
